import './styles/NoticeBoard.scss';
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { AppContext } from '../Context';
import { useContext, useState, useEffect, createRef } from 'react';
import ZoomImg from './ZoomImg';
import { Browser } from '@capacitor/browser';
import { useHistory } from 'react-router';
import Portal from './Portal';

//mui icons
import Close from '@mui/icons-material/Close';

//classes
import Notice from '../classes/notice';

interface Props {
    notices: Notice[], SetNoticeBoardShouldShow: any
}

const NoticeBoard: React.FC<Props> = ({ notices, SetNoticeBoardShouldShow }) => {
    //contexts
    const appContext = useContext(AppContext);
    //states
    const [currentPage, SetCurrentPage] = useState(0);
    const [noticeBoardPostersRef, SetNoticeBoardPostersRef] = useState<any[]>([] as any[]);
    //router objs
    const history = useHistory();

    //reset noticeBoardPostersRefs
    useEffect(() => {
        const _noticeBoardPostersRef = [] as any[];
        notices.map(() => {
            _noticeBoardPostersRef.push(createRef());
        });
        SetNoticeBoardPostersRef([..._noticeBoardPostersRef]);
    }, [notices]);

    //watch for pageUpdate, scrollIntoView
    useEffect(() => {
        if (noticeBoardPostersRef.length > 0)
            noticeBoardPostersRef[currentPage].current.scrollIntoView({ behaviour: 'smooh' });
    }, [noticeBoardPostersRef, currentPage]);

    return (
        <Portal>
            <div className={'NoticeBoard ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : '')}>
                <div className='NoticeBoard-scroll'>
                    {
                        notices.map((notice: Notice, i: number) => {
                            return (
                                <div className={'NoticeBoard-poster ' + (currentPage == i ? '' : 'hide')} ref={noticeBoardPostersRef[i]} onClick={() => {
                                    if (notice.action.trim().length > 0) {
                                        if (notice.action.includes('http'))
                                            Browser.open({ url: notice.action });
                                        else {
                                            history.push(notice.action);
                                        }
                                    }
                                }}>
                                    <ZoomImg src={notice.url} />
                                </div>
                            )
                        })
                    }
                </div>
                <button className='NoticeBoard-next-btn' onClick={() => { currentPage != (notices.length - 1) ? SetCurrentPage(currentPage + 1) : SetCurrentPage(0); }}>
                    Next {(currentPage + 1)}/{notices.length}
                </button>
                <button className='NoticeBoard-close-btn' onClick={() => SetNoticeBoardShouldShow(false)}><Close /></button>
            </div>
        </Portal>
    );
}
export default NoticeBoard;